export default __webpack_public_path__ + "static/media/Bunga.740720fb.png";